module.exports = __webpack_public_path__ + "c4f7fdb3afc07ee3504d1144456fe514.svg";